import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/chat-filter.svg'
import _imports_1 from '@/assets/images/empty-chat.png'
import _imports_2 from '@/assets/icons/dots.svg'


const _withScopeId = n => (_pushScopeId("data-v-01dc871c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mainchatbox__wrapper"
}
const _hoisted_2 = { class: "chatbox__left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chatbox__heading" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Chat")
], -1))
const _hoisted_4 = { class: "chatbox__right" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "chatbox__section" }
const _hoisted_7 = {
  key: 0,
  class: "chatbox__selection_inner"
}
const _hoisted_8 = {
  key: 1,
  class: "chatbox__message"
}
const _hoisted_9 = { class: "chatbox__center" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "chat-panel__header-right" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_13 = { class: "chat-panel__filter" }
const _hoisted_14 = { class: "chat-panel__filter-content" }
const _hoisted_15 = { class: "chat-panel__filter-content" }
const _hoisted_16 = { class: "archive__title" }
const _hoisted_17 = { class: "archive__icon" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Archived", -1))
const _hoisted_20 = { class: "chat_listing_container" }
const _hoisted_21 = { class: "panel-container" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "All", -1))
const _hoisted_23 = {
  key: 0,
  class: "chat-member__notification"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Group Chats", -1))
const _hoisted_25 = {
  key: 0,
  class: "chat-member__notification"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Project Chat", -1))
const _hoisted_27 = {
  key: 0,
  class: "chat-member__notification"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Workstation Members", -1))
const _hoisted_29 = {
  key: 0,
  class: "chat-member__notification"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Trade Network Chat", -1))
const _hoisted_31 = {
  key: 0,
  class: "chat-member__notification"
}
const _hoisted_32 = {
  key: 0,
  class: "tw-flex tw-justify-center tw-items-center tw-h-[calc(100dvh-440px)]"
}
const _hoisted_33 = { class: "empty-screen-text tw-w-[215px] tw-max-w-full tw-mt-5" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tw-text-gray-500 tw-text-sm tw-font-medium" }, " No Chats Yet ", -1))
const _hoisted_36 = { class: "tw-text-gray-500 tw-text-sm tw-font-medium" }
const _hoisted_37 = { class: "chat-panel__inner" }
const _hoisted_38 = { class: "chat-member-list" }
const _hoisted_39 = ["onClick", "onMouseleave"]
const _hoisted_40 = { class: "chat-member__image" }
const _hoisted_41 = ["src"]
const _hoisted_42 = {
  key: 1,
  class: "status_wrapper online"
}
const _hoisted_43 = {
  key: 2,
  class: "status_wrapper offline"
}
const _hoisted_44 = { class: "chat-member__content" }
const _hoisted_45 = { class: "chat-member__title" }
const _hoisted_46 = { class: "chat-member__name tw-truncate" }
const _hoisted_47 = { class: "tw-truncate" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  key: 1,
  class: "chat-member__date"
}
const _hoisted_50 = {
  key: 2,
  class: "chat-member__date"
}
const _hoisted_51 = { class: "chat-panel__setting-menu-icon" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "chat-panel__setting-menu-inner is-active" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["src"]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Delete", -1))
const _hoisted_59 = {
  key: 0,
  class: "chat-member__content-inner !tw-mt-0"
}
const _hoisted_60 = { class: "chat-member__text" }
const _hoisted_61 = {
  key: 0,
  class: "chat-member__notification"
}
const _hoisted_62 = {
  key: 1,
  class: "chat-member__content-inner !tw-mt-0"
}
const _hoisted_63 = { class: "chat-member__text" }
const _hoisted_64 = {
  key: 0,
  class: "chat-member__notification"
}
const _hoisted_65 = {
  key: 2,
  class: "chatbox__edit__message"
}
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { class: "chatbox__left" }
const _hoisted_68 = { class: "chatbox__img" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chatbox__heading" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Create a New Group")
], -1))
const _hoisted_70 = { class: "chatbox__right" }
const _hoisted_71 = {
  key: 1,
  class: "chat_groups_list"
}
const _hoisted_72 = { class: "chat_groups_list_tab_content" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { class: "create_group_wrapper" }
const _hoisted_75 = { class: "create_group_image" }
const _hoisted_76 = ["src"]
const _hoisted_77 = {
  key: 0,
  class: "status_wrapper online"
}
const _hoisted_78 = {
  key: 1,
  class: "status_wrapper offline"
}
const _hoisted_79 = { class: "create_group_name" }
const _hoisted_80 = { class: "group_status" }
const _hoisted_81 = {
  key: 0,
  class: "chat_groups_list_empty"
}
const _hoisted_82 = { class: "chat_groups_list_tab_content" }
const _hoisted_83 = ["onClick"]
const _hoisted_84 = { class: "create_group_wrapper" }
const _hoisted_85 = { class: "create_group_image" }
const _hoisted_86 = ["src"]
const _hoisted_87 = {
  key: 0,
  class: "status_wrapper online"
}
const _hoisted_88 = {
  key: 1,
  class: "status_wrapper offline"
}
const _hoisted_89 = { class: "create_group_name" }
const _hoisted_90 = { class: "group_status" }
const _hoisted_91 = {
  key: 0,
  class: "chat_groups_list_empty"
}
const _hoisted_92 = { class: "open__chat" }
const _hoisted_93 = { key: 0 }

import { ref, computed, onBeforeUnmount, onMounted, inject, watch } from "vue";
import MessageChatComponent from "@/core/components/MessageChatComponent.vue";
import TradeNetworkService from "@/core/services/trade-network.service";
import { WORKSTATION } from "@/store/modules/workstation";
import { useStore } from "vuex";
import { USER_STORE } from "@/store/modules/user";
import NewGroupChatComponent from "@/core/components/NewGroupChatComponent.vue";
import chatService from "@/core/services/chat.service";
import { CHATMESSAGE } from "@/store/modules/chat-message";
import {
  getImageApiUrl,
  profileImagesData,
  setDirectStoragePathToImage,
} from "@/core/utils/common";
import $axios from "@/core/utils/axios-api-config";
import { UserRolesEnum } from "@/core/enums/RolesEnum";
import CommonLoader from "@/core/components/CommonLoader.vue";
import UserProfileLogo from "@/core/components/UserProfileLogo.vue";
import {
  UserMessagesRoomStatusEnum,
  RoomPanel,
  ChatTypeEnum,
} from "@/core/enums/chatsEnums";
import DailyIframe from "@daily-co/daily-js";
import VideoComponent from "@/core/components/VideoComponent.vue";
import { CallTypesEnums } from "@/core/enums/VideoEnum";
// import KrystalChatComponent from "../KrystalChatComponent.vue";
import moment from "moment";
import { MEMBER_STORE } from "@/store/modules/manage-member";
import { CONNECTIONS } from "@/store/modules/connections";

export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalChatsComponent',
  emits: ["on-close"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const emits = __emit;
const user = computed(() => store.getters[`${USER_STORE}/user`]);
const userImage = computed(() => store.getters[`${USER_STORE}/userImage`]);
const isActive = ref(false);
const isCreateChat = ref(false);
const searchChats = ref("");
const searchNetworkUsers = ref("");
const isOpenMessageChatBox = ref(false);
const isCreateNewGroupChat = ref(false);
const usersNetworkList = ref([]) as any;
const userImagesMap = ref({}) as any;
const isLoading = ref(false);
const videoConsultationStatus = ref(false);
const roomDetails = ref({}) as any;
const videoComponent = ref(null) as any;
const inviteUsers = ref([]);
const selectedPanel = ref("all");
const isSort = ref(true);
const activePanel = ref([0, 1, 2, 3]) as any;
const panelMap = ref({
  all: "all",
  members: "members",
  group_chats: "group_chats",
  project_chats: "project_chats",
  workstation_chats: "workstation_chats",
}) as any;

const activePanelSort = ref("all");

const isShowClearFilter = ref(false);
const filterNames = ref({
  all: "a friend.",
  workstation_members: "with Workstation Members",
  group_chats: "with Group Members",
  project_chats: "with Project Members",
  workstation_chats: "with Trade Network Members",
}) as any;
const setSelectedPanel = (panel: any) => {
  if (panelMap.value[panel]) {
    selectedPanel.value = panelMap.value[panel];
    activePanelSort.value = panelMap.value[panel];

    if (activePanelSort.value !== panelMap.value.all) {
      isShowClearFilter.value = true;
    } else {
      if (!searchChats.value) isShowClearFilter.value = false;
    }
  }
};
const toggleChatBox = () => {
  isOpenMessageChatBox.value = !isOpenMessageChatBox.value;
  isCreateNewGroupChat.value = false;
  isCreateChat.value = false;
};
const tab = ref("members");
const tabs = ref(["members", "workStations"]);
const isShowArchived = ref(false);
const selectedFilter = ref("all");
const onCreateNewChat = async () => {
  isCreateChat.value = true;

  try {
    await getUserWorkStationUserList();
  } catch (error) {
    console.log(error);
  }
};
const filterChatRoom = computed(() => {
  return chatRooms.value.slice(0, 3);
});
const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);
const getChatMessagesRooms = computed(
  () => store.getters[`${CHATMESSAGE}/filterMessagesRooms`]
);
const allMessagesRooms = computed(
  () => store.getters[`${CHATMESSAGE}/getChatMessagesRooms`]
);

const chatRooms = computed(
  () => store.getters[`${CHATMESSAGE}/getChatBoxRooms`]
);

const filteredRooms = computed(() => {
  let rooms = [];

  if (selectedFilter.value === "all") {
    rooms = [
      ...membersRooms.value,
      ...groupRooms.value,
      ...workStationRooms.value,
      ...projectRoom.value,
    ];
  } else if (selectedFilter.value === "workstation_members") {
    rooms = membersRooms.value;
  } else if (selectedFilter.value === "group_chats") {
    rooms = groupRooms.value;
  } else if (selectedFilter.value === "project_chats") {
    rooms = projectRoom.value;
  } else if (selectedFilter.value === "workstation_chats") {
    rooms = workStationRooms.value;
  }

  return rooms.sort((a: any, b: any) => {
    const dateA = new Date(a.userMessages?.dateUpdated || 0).getTime();
    const dateB = new Date(b.userMessages?.dateUpdated || 0).getTime();
    return dateB - dateA;
  });
});

const keyExists = (key: any) => {
  return key in userImagesMap.value;
};

const addUserImage = (userProfileImg: any, imageUrl: string) => {
  if (!keyExists(userProfileImg)) {
    userImagesMap.value[userProfileImg] = imageUrl;
    return true;
  } else {
    return false;
  }
};

const filterChatMessageRoom = computed(() => {
  const searchTerm = searchChats.value.trim().toLowerCase();
  if (!searchTerm || searchTerm.length < 1) {
    return getChatMessagesRooms.value;
  } else {
    return getChatMessagesRooms.value.filter((message: any) => {
      if (message.isGroup === 1) {
        return message.groupName.toLowerCase().includes(searchTerm);
      } else {
        return (
          message.toUserWorkStationId?.name
            ?.toLowerCase()
            .includes(searchTerm) ||
          message.toUser?.firstName?.toLowerCase().includes(searchTerm) ||
          message.toUser?.lastName?.toLowerCase().includes(searchTerm)
        );
      }
    });
  }
});
const userWorkStationImage = computed(
  () => store.getters[`${USER_STORE}/userWorkStationImage`]
);
const filterRooms = (filter: any) => {
  selectedFilter.value = filter;
};
const getUnreadCount = (room: any): any => {
  if (isGroupRoom(room) || room.chatType === ChatTypeEnum.DISPUTE_PROJECT) {
    return getCountForSingleGroupMessage(room);
  }

  return room?.unreadMessagesCount || 0;
};
const getCountForSingleGroupMessage = (room: any) => {
  if (!room || !room.userMessageStatus || !room.userMessages) {
    return 0;
  }

  const unreadCount = room?.userMessageStatus?.reduce(
    (count: any, message: any) => {
      const unreadInStatuses =
        message?.statuses?.filter(
          (status: any) =>
            status.state === "unread" &&
            status.user?.id === user.value.id &&
            status.userWorkstation?.id === activeUserWorkstation.value?.id
        )?.length || 0;

      return count + unreadInStatuses;
    },
    0
  );

  return unreadCount;
};

//global chat data start
const selectedUserMessages: any = ref([]) as any;
const projectId = ref(null) as any;
const getUserRoomsList = async () => {
  try {
    isLoading.value = true;
    let userMessageRoomsData = (await store.dispatch(
      `${CHATMESSAGE}/getUserRoomMessages`,
      activeUserWorkstation.value.id
    )) as any;
    if (userMessageRoomsData) {
      //user Image
      if (
        !keyExists(user.value?.userPublicProfile.profileImage) &&
        userImage.value
      ) {
        userImagesMap.value[user.value.userPublicProfile?.profileImage] =
          userImage.value;
      }
      //activeWorkStation Image
      if (
        !keyExists(activeUserWorkstation.value.profileImage) &&
        userWorkStationImage.value
      ) {
        userImagesMap.value[activeUserWorkstation.value.profileImage] =
          userWorkStationImage.value;
      }
      userMessageRoomsData.map((userRoom: any) => {
        if (userRoom.toWorkstationId?.profileImage)
          getUserWorkStationProfileImage(
            userRoom.toWorkstationId?.profileImage
          );
        if (userRoom.toUser?.profileImage)
          getUserWorkStationProfileImage(userRoom.toUser?.profileImage);

        if (userRoom.isGroup) {
          getUserWorkStationProfileImage(userRoom.groupAvatar);
          userRoom.userMessageGroups.map((groupMember: any) => {
            if (groupMember.userWorkStation?.profileImage)
              getUserWorkStationProfileImage(
                groupMember.userWorkStation?.profileImage
              );
          });
        }
      });

      if (isProjectOwner.value) {
        /*project show only for property owner */
        const filterUserMessages = getChatMessagesRooms.value.filter(
          (message: any) => {
            if (message?.project?.id) {
              if (message.status !== UserMessagesRoomStatusEnum.PENDING) {
                return true;
              }
            } else {
              return true;
            }
          }
        );
      }

      return userMessageRoomsData;
    }
  } catch (error) {
    console.log("error", error);
  } finally {
    isLoading.value = false;
  }
};

const saveNewUserGroup = async (formData: any) => {
  try {
    isCreateNewGroupChat.value = false;
    isCreateChat.value = false;

    addUserImage(formData.groupAvatar, formData.groupUrl);

    delete formData.groupUrl;
    const newUserRoom = (await chatService.createUserGroupMessageRoom(
      formData
    )) as any;
    if (newUserRoom) {
      const userRoom = {
        ...newUserRoom,
        unreadMessagesCount: 0,
        userMessageGroups: [],
        userMessages: null,
        userMessageAttachments: [],
        project: null,
        userWorkstation: {
          id: activeUserWorkstation.value?.id,
          name: activeUserWorkstation.value?.name,
          profileImage: activeUserWorkstation.value?.profileImage,
        },
      };
      store.commit(`${CHATMESSAGE}/addFilterMessagesRooms`, userRoom);
      store.commit(`${CHATMESSAGE}/addUserRoomMessages`, userRoom);

      if (newUserRoom?.id) subscribeUserMessageRoom(newUserRoom?.id);
    }
  } catch (error) {
    console.log(error);
  }
};

const saveNewGroupMembers = async (formData: any) => {
  try {
    await chatService.addUserGroupMessageRoom(formData);
    await init();
  } catch (error) {
    console.log(error);
  }
};
//global chat data end
const createMessageChatBox = async (data: any) => {
  const receiverUserId = data.receiverWorkstation?.user?.id;
  let formData = {
    fromUser: user.value.id,
    toUser: data?.toUserId,
    isUserChat: data.isUserChat ? 1 : 0,
  } as any;

  if (!data.isUserChat) {
    formData = {
      ...formData,
      toUser: receiverUserId,
      toWorkstationId: data.receiverWorkstation.id,
    };
  }

  if (user.value.id && receiverUserId && data.receiverWorkstation?.id) {
    const isUserChatExists = allMessagesRooms.value?.find((msg: any) => {
      if (msg.isUserChat) {
        return (
          msg.toWorkstationId?.id === data.receiverWorkstation.id &&
          msg.fromWorkstationId?.id === data.receiverWorkstation.id &&
          msg.toUser.id === data.toUser.id
        );
      }
      return (
        msg.toWorkstationId?.id == data.receiverWorkstation.id && !msg.isGroup
      );
    });
    //await init call restrict to
    if (!isUserChatExists) {
      try {
        const response = (await chatService.createUserMessageRoom(
          formData
        )) as any;
        if (response && activeUserWorkstation.value) {
          //Todo fixes

          const userRoom = {
            ...response,
            toUser: {
              id: data.receiverWorkstation?.user?.id,
              firstName: data.receiverWorkstation?.user?.firstName,
              lastName: data.receiverWorkstation?.user?.lastName,
              userBusinessDetails:
                data.receiverWorkstation?.user?.userBusinessDetails,
              userPublicProfile:
                data.receiverWorkstation?.user?.userPublicProfile,
              profileImage:
                data.receiverWorkstation?.user?.userPublicProfile?.profileImage,
            },
            toWorkstationId: {
              id: data.receiverWorkstation?.id,
              name: data.receiverWorkstation?.name,
              profileImage: data.receiverWorkstation?.profileImage,
            },
            unreadMessagesCount: 0,
            userMessageGroups: [],
            userMessages: null,
            userMessageAttachments: [],

            userWorkstation: {
              id: data.receiverWorkstation?.id,
              name: data.receiverWorkstation?.name,
              profileImage: data.receiverWorkstation?.profileImage,
            },
          };

          store.commit(`${CHATMESSAGE}/addFilterMessagesRooms`, userRoom);
          store.commit(`${CHATMESSAGE}/addUserRoomMessages`, userRoom);
          if (userRoom?.id) subscribeUserMessageRoom(userRoom?.id);

          const hasPendingStatus = response?.dispute?.dispute_offers?.some(
            (offer: any) => offer?.status === "pending"
          );

          const userMessageRoomDetails = {
            id: response?.id,
            isGroup: response?.isGroup,
            groupName: response?.groupName,
            groupAvatar: response?.groupAvatar,
            groupAvatarUrl: response?.groupAvatarUrl,
            parentId: response?.parentId,
            isUserChat: response?.isUserChat,
            isArchiveRoom: response?.isArchiveRoom,
            chatType: response?.chatType,
            dispute: response?.dispute,
          };

          const userDetails = {
            userMessageRoomDetails: userMessageRoomDetails,
            receiverUserWorkstation: {
              id: data?.receiverWorkstation?.id,
              name: data?.receiverWorkstation?.name,
              profileImage: data?.receiverWorkstation?.profileImage,
              user: {
                id: data?.receiverWorkstation.user?.id,
                firstName: data?.receiverWorkstation.user?.firstName,
                lastName: data?.receiverWorkstation.user?.lastName,
                profileImage: data?.receiverWorkstation?.user?.profileImage,
              },
              isUserChat: data?.isUserChat,
            },
            senderUserWorkstation: {
              id: activeUserWorkstation.value.id,
              name: activeUserWorkstation.value.name,
              profileImage: activeUserWorkstation.value.profileImage,
              user: {
                id: user.value.id,
                firstName: user.value.firstName,
                lastName: user.value.lastName,
              },
            },
            userMessages: [],
          };
          store.commit(`${CHATMESSAGE}/addChatBoxRoom`, userDetails);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      openMessageChatBox(isUserChatExists);
    }
    isCreateNewGroupChat.value = false;
    isCreateChat.value = false;
  }
};
const closeMessageChatBox = (id: any, isCloseChatBox = false) => {
  const filterChatRooms = chatRooms.value.filter(
    (msg: any) => msg.userMessageRoomDetails.id !== id
  );
  store.commit(`${CHATMESSAGE}/setChatBoxRooms`, filterChatRooms);
  if (isCloseChatBox) {
    toggleChatBox();
  }
};

const isProjectChatLock = (data: any) => {
  return data?.project &&
    data?.project?.id &&
    data.status === UserMessagesRoomStatusEnum.PENDING
    ? true
    : false;
};

const getTeamMember = async () => {
  try {
    const response = await store.dispatch(`${MEMBER_STORE}/getTeamMember`, {
      userId: user.value?.id,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};
const getUserWorkStationUserList = async () => {
  try {
    let networkList =
      (await TradeNetworkService.getAllContractorWithOutCategory(
        activeUserWorkstation.value?.id
      )) as any;
    networkList = networkList?.data;
    networkList = networkList
      .map((networkMember: any) => {
        return {
          ...networkMember,
          isUserChat: false,
          receiverWorkstation: {
            ...networkMember.receiverWorkstation,
          },
        };
      })
      .filter((member: any) => {
        //invited users Launch workStation filter login user workStations
        if (activeUserWorkstation.value.isInvited) {
          return member.receiverWorkstation.user.id !== user.value.id;
        }
        return true;
      });

    // invite Users
    let filterUsers = [];

    if (inviteUsers.value.length) {
      filterUsers = inviteUsers.value
        .filter(
          (userData: any) =>
            user.value?.id !== userData?.toUserId &&
            userData.invitationStatus === "accepted"
        )
        .map((data: any) => {
          return {
            ...data,
            isUserChat: true,
            receiverWorkstation: {
              id: data.userWorkstation.id,
              name: data.userWorkstation.name,
              isAvailable: data.userWorkstation.isAvailable,
              profileImage: data.userWorkstation.profileImage,
              imgUrl: null,
              user: {
                id: data.toUser?.id,
                firstName: data.toUser?.firstName,
                lastName: data.toUser?.lastName,
                userBusinessDetails: data.toUser?.userBusinessDetails,
                userPublicProfile: data.toUser?.userPublicProfile,
                profileImage: data.toUser?.userPublicProfile?.profileImage,
                imgUrl: null,
              },
            },
          };
        });
    }

    let filterConnections = [] as any;
    if (allConnectionList.value.length && isProjectOwner.value) {
      filterConnections = allConnectionList.value
        .filter(
          (userData: any) =>
            user.value?.id !== userData?.toUserId &&
            userData.invitationStatus === "accepted"
        )
        .map((data: any) => {
          return {
            ...data,
            receiverWorkstation: {
              id: data.userWorkstation.id,
              name: data.userWorkstation.name,
              isAvailable: data.userWorkstation.isAvailable,
              profileImage: data.userWorkstation.profileImage,
              imgUrl: null,
              user: {
                id: data.toUser?.id,
                firstName: data.toUser?.firstName,
                lastName: data.toUser?.lastName,
                userBusinessDetails: data.toUser?.userBusinessDetails,
                userPublicProfile: data.toUser?.userPublicProfile,
                profileImage: data.toUser?.userPublicProfile?.profileImage,
                imgUrl: null,
              },
            },
          };
        });
    }

    usersNetworkList.value = [
      ...networkList,
      ...filterUsers,
      ...filterConnections,
    ];

    //get Image
    for (const netWorkData of usersNetworkList.value) {
      if (netWorkData.receiverWorkstation?.profileImage)
        getUserWorkStationProfileImage(
          netWorkData.receiverWorkstation.profileImage
        );
      if (netWorkData.receiverWorkstation.user?.profileImage)
        getUserWorkStationProfileImage(
          netWorkData.receiverWorkstation.user?.profileImage
        );
    }
    return usersNetworkList.value;
  } catch (error) {
    console.log("hello", error);
  }
};
const onClickProjectChat = async () => {
  try {
    await getUserWorkStationUserList();
  } catch (error) {
    console.log("error", error);
  }
};
const onClickGroupChat = async () => {
  try {
    const response = await getUserWorkStationUserList();
    if (response) {
      isCreateNewGroupChat.value = true;
    }
  } catch (error) {
    console.log("error", error);
  }
};
const openMessageChatBox = async (message: any) => {
  try {
    if (isProjectChatLock(message)) return;

    let messageRoomId = message?.id;
    const isOpenMessageBox = chatRooms.value?.find(
      (msg: any) => msg?.userMessageRoomDetails?.id === messageRoomId
    );
    if (!isOpenMessageBox && messageRoomId) {
      const userMessageRoomDetails = {
        id: message?.id,
        isGroup: message?.isGroup,
        groupName: message?.groupName,
        groupAvatar: message?.groupAvatar,
        groupAvatarUrl: message?.groupAvatarUrl,
        parentId: message?.parentId,
        project: message?.project,
        projectStatus: message?.status,
        unReadMessageCount: message?.unreadMessagesCount,
        isUserChat: message?.isUserChat,
        isArchiveRoom: message?.isArchiveRoom,
        chatType: message?.chatType,
        dispute: message?.dispute,
      };
      const userDetails = {
        userMessageRoomDetails: userMessageRoomDetails,
        receiverUserWorkstation: {
          ...message?.toWorkstationId,
          user: message?.toUser,
          isUserChat: message?.isUserChat,
        },
        senderUserWorkstation: {
          id: activeUserWorkstation.value.id,
          name: activeUserWorkstation.value.name,
          profileImage: userWorkStationImage.value,
          user: {
            id: user.value.id,
            firstName: user.value.firstName,
            lastName: user.value.lastName,
          },
        },
        userMessages: [],
      };

      store.commit(`${CHATMESSAGE}/addChatBoxRoom`, userDetails);
    } else {
      const index = chatRooms.value.findIndex(
        (room: any) => room?.userMessageRoomDetails?.id === messageRoomId
      );
      if (index > 0) {
        const filterChatRooms = chatRooms.value.filter(
          (room: any) => room?.userMessageRoomDetails?.id !== messageRoomId
        );
        store.commit(`${CHATMESSAGE}/setChatBoxRooms`, filterChatRooms);
        store.commit(`${CHATMESSAGE}/addChatBoxRoom`, isOpenMessageBox);
      }
    }

    const filterMessageCount = filterChatMessageRoom.value?.find(
      (room: any) => room?.id === messageRoomId
    );

    if (filterMessageCount) filterMessageCount.unreadMessagesCount = 0;

    const matchingStatuses = filterMessageCount?.userMessageStatus.filter(
      function (status: any) {
        return status?.statuses.some(function (s: any) {
          return (
            s.user.id === user.value.id &&
            s.userWorkstation.id === activeUserWorkstation.value.id
          );
        });
      }
    );

    if (matchingStatuses && matchingStatuses?.length > 0) {
      matchingStatuses?.forEach(function (status: any) {
        status?.statuses.forEach(function (s: any) {
          if (
            s.user.id === user.value.id &&
            s.userWorkstation.id === activeUserWorkstation.value.id
          ) {
            s.state = "read";
          }
        });
      });
    }
  } catch (error) {
    console.log(error);
  }

  if (window.innerWidth <= 720) {
    isOpenMessageChatBox.value = !isOpenMessageChatBox.value;
    isCreateNewGroupChat.value = false;
    isCreateChat.value = false;
  }
};
const getTimeElapsedString = (timestamp: any) => {
  const previous = new Date(timestamp) as any;
  const current = new Date() as any;

  const elapsed = current - previous;

  const seconds = Math.floor(elapsed / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  if (weeks > 0) {
    return weeks === 1 ? "1 week ago" : `${weeks} weeks ago`;
  } else if (days > 0) {
    return days === 1 ? "1 day ago" : `${days} days ago`;
  } else if (hours > 0) {
    return hours === 1 ? "1 hour ago" : `${hours} hours ago`;
  } else if (minutes > 0) {
    return minutes === 1 ? "1 minute ago" : `${minutes} minutes ago`;
  } else {
    return "Just now";
  }
};

const subscribeRoomUpdates = async () => {
  const roomChannel = pusher?.subscribe(
    `new-room-message-${activeUserWorkstation.value.id}-${user.value.id}`
  );
  roomChannel
    ?.unbind("new.room.message")
    ?.bind("new.room.message", (userRoom: any) => {
      if (userRoom) {
        const roomExists = allMessagesRooms.value.some(
          (el: any) => el.id == userRoom.id
        );
        if (roomExists) {
          {
            const filterUserMessages = [...getChatMessagesRooms.value].map(
              (el: any) => {
                if (el.id == userRoom.id) {
                  return { ...el, userMessages: userRoom.userMessages };
                } else {
                  return el;
                }
              }
            );
            store.commit(
              `${CHATMESSAGE}/setFilterMessageRooms`,
              filterUserMessages
            );
            store.commit(
              `${CHATMESSAGE}/setUserRoomMessages`,
              filterUserMessages
            );
          }
        } else {
          if (userRoom.isGroup)
            getUserWorkStationProfileImage(userRoom?.groupAvatar);
          else {
            if (userRoom.toWorkstationId)
              getUserWorkStationProfileImage(
                userRoom?.toWorkstationId.profileImage
              );
            if (userRoom.toUser)
              getUserWorkStationProfileImage(userRoom?.toUser.profileImage);
          }
          const isToWorkstation =
            userRoom.toWorkstationId?.id === activeUserWorkstation.value.id;
          const isToUser = userRoom.toUser?.id === user.value?.id;
          userRoom = {
            ...userRoom,
            unreadMessagesCount: 1,
            toWorkstationId: isToWorkstation
              ? {
                  id: userRoom.fromWorkstationId?.id,
                  name: userRoom.fromWorkstationId?.name,
                  profileImage: userRoom.fromWorkstationId?.profileImage,
                  status: userRoom.fromWorkstationId?.status,
                }
              : {
                  id: userRoom.toWorkstationId?.id,
                  name: userRoom.toWorkstationId?.name,
                  profileImage: userRoom.toWorkstationId?.profileImage,
                  status: userRoom.toWorkstationId?.status,
                },
            fromWorkstationId: isToWorkstation
              ? {
                  id: userRoom.toWorkstationId?.id,
                  name: userRoom.toWorkstationId?.name,
                  profileImage: userRoom.toWorkstationId?.profileImage,
                  status: userRoom.toWorkstationId?.status,
                }
              : {
                  id: userRoom.fromWorkstationId?.id,
                  name: userRoom.fromWorkstationId?.name,
                  profileImage: userRoom.fromWorkstationId?.profileImage,
                  status: userRoom.fromWorkstationId?.status,
                },

            toUser: isToUser
              ? {
                  id: userRoom.fromUser?.id,
                  firstName: userRoom.fromUser?.firstName,
                  lastName: userRoom.fromUser?.lastName,
                  dateCreated: userRoom.fromUser?.dateCreated,
                  profileImage:
                    userRoom.fromUser?.userPublicProfile?.profileImage,
                }
              : {
                  id: userRoom.toUser?.id,
                  firstName: userRoom.toUser?.firstName,
                  lastName: userRoom.toUser?.lastName,
                  dateCreated: userRoom.toUser?.dateCreated,
                  profileImage:
                    userRoom.toUser?.userPublicProfile?.profileImage,
                },
            fromUser: isToUser
              ? {
                  id: userRoom.toUser?.id,
                  firstName: userRoom.toUser?.firstName,
                  lastName: userRoom.toUser?.lastName,
                  dateCreated: userRoom.toUser?.dateCreated,
                  profileImage:
                    userRoom.toUser?.userPublicProfile?.profileImage,
                }
              : {
                  id: userRoom.fromUser?.id,
                  firstName: userRoom.fromUser?.firstName,
                  lastName: userRoom.fromUser?.lastName,
                  dateCreated: userRoom.fromUser?.dateCreated,
                  profileImage:
                    userRoom.fromUser?.userPublicProfile?.profileImage,
                },
          };
          if (userRoom?.id) subscribeUserMessageRoom(userRoom?.id);
          store.commit(`${CHATMESSAGE}/addFilterMessagesRooms`, userRoom);
          store.commit(`${CHATMESSAGE}/addUserRoomMessages`, userRoom);
        }
      }
      return;
    });
  subscribeChannelList.value.push(roomChannel);
};
const init = async () => {
  if (activeUserWorkstation.value) {
    const userMessageRooms = await getUserRoomsList();
    userMessageRooms?.map((data: any) => {
      let roomId = data?.id;
      if (data?.isGroup && data?.parentId) {
        roomId = data?.parentId;
      }
      if (roomId) subscribeUserMessageRoom(roomId);

      if (data.chatType === ChatTypeEnum.DISPUTE_PROJECT) {
        subscribeDisputeProjectRequest(data);
      }
    });
    subscribeRoomUpdates();
  }
};

const closeChatBox = () => {
  store.commit(`${CHATMESSAGE}/setChatBoxRooms`, []);
  emits("on-close");
};
const isProjectOwner = computed(() => {
  if (user.value?.role?.name === UserRolesEnum.PROPERTY_OWNER) {
    return true;
  }
  return false;
});

watch(
  () => activeUserWorkstation.value?.id,
  async (newValue: any, oldValue: any) => {
    if (newValue !== oldValue && activeUserWorkstation.value?.id) {
      await init();
      await store.dispatch(`${CHATMESSAGE}/getKrystalConversation`);
      //start direct with group getNetworkContactList issue
      if (isProjectOwner.value)
        await store.dispatch(`${CONNECTIONS}/getUserConnectionList`, {
          userId: user.value?.id,
        });
      inviteUsers.value = await getTeamMember();
      await getUserWorkStationUserList();
    }
  },
  { immediate: true, deep: true }
);

const getProjectChatRequests = computed(
  () => store.getters[`${CHATMESSAGE}/getProjectChatRequests`]
);
const membersRooms = computed(() => {
  return filterChatMessageRoom.value.filter(
    (room: any) => room.isUserChat && !room.isGroup
  );
});

const projectRoom = computed(() => {
  return filterChatMessageRoom.value.filter((room: any) => {
    if (room.project?.id && room.isGroup) {
      if (isProjectOwner.value) {
        return room.status !== UserMessagesRoomStatusEnum.PENDING;
      }
      return true;
    } else return false;
  });
});
const groupRooms = computed(() => {
  return filterChatMessageRoom.value.filter(
    (room: { isGroup: boolean; project?: boolean }) =>
      room.isGroup && !room.project
  );
});

const workStationRooms = computed(() => {
  return filterChatMessageRoom.value.filter(
    (room: any) => !room.isUserChat && !room.isGroup
  );
});

const membersUnreadMsgCount = computed(() => {
  return membersRooms.value.reduce((acc: number, room: any) => {
    return room.unreadMessagesCount > 0 ? acc + 1 : acc;
  }, 0);
});

const groupsUnreadMsgCount = computed(() => {
  let totalUnreadCount = 0;

  groupRooms?.value?.forEach((grp: any) => {
    let groupHasUnreadMessages = false;
    grp?.userMessageStatus?.forEach((message: any) => {
      const unreadStatuses = message?.statuses?.filter((status: any) => {
        return (
          status.state === "unread" &&
          status.user?.id === user.value.id &&
          status.userWorkstation?.id === activeUserWorkstation?.value.id
        );
      });

      if (unreadStatuses?.length > 0) {
        groupHasUnreadMessages = true;
      }
    });

    if (groupHasUnreadMessages) {
      totalUnreadCount += 1;
    }
  });

  return totalUnreadCount;
});

const projectsUnreadMsgCount = computed(() => {
  // return projectRoom.value.reduce((acc: number, room: any) => {
  //   return room.unreadMessagesCount > 0 ? acc + 1 : acc;
  // }, 0);

  let totalUnreadCount = 0;

  projectRoom?.value?.forEach((grp: any) => {
    let projectHasUnreadMessages = false;
    grp?.userMessageStatus?.forEach((message: any) => {
      const unreadStatuses = message?.statuses?.filter((status: any) => {
        return (
          status.state === "unread" &&
          status.user?.id === user.value.id &&
          status.userWorkstation?.id === activeUserWorkstation?.value.id
        );
      });

      if (unreadStatuses?.length > 0) {
        projectHasUnreadMessages = true;
      }
    });

    if (projectHasUnreadMessages) {
      totalUnreadCount += 1;
    }
  });

  return totalUnreadCount;
});
const workStationUnreadMsgCount = computed(() => {
  return workStationRooms.value.reduce((acc: number, room: any) => {
    return room.unreadMessagesCount > 0 ? acc + 1 : acc;
  }, 0);
});
watch(
  () => getProjectChatRequests.value,
  async (newValue: any, oldValue: any) => {
    if (newValue !== oldValue && getProjectChatRequests.value) {
      await init();
      const roomId = newValue?.id;
      isOpenMessageChatBox.value = true;
      const roomData = getChatMessagesRooms.value.find(
        (room: any) => room.id === roomId
      );
      openMessageChatBox(roomData);
      await store.dispatch(`${CHATMESSAGE}/setProjectChatRequests`, null);
      activePanel.value = RoomPanel.PROJECT_CHAT;
    }
  },
  { immediate: true, deep: true }
);
const getNetworkDirectMessage = computed(
  () => store.getters[`${CHATMESSAGE}/getNetworkDirectMessage`]
);
const getCurrentMessageType = computed(
  () => store.getters[`${CHATMESSAGE}/getCurrentMessageType`]
);
const allConnectionList = computed(
  () => store.getters[`${CONNECTIONS}/getUserFilteredConnection`]
);
watch(
  () => getNetworkDirectMessage.value,
  async (value: any) => {
    if (value) {
      isOpenMessageChatBox.value = true;
      createMessageChatBox(value);
      await store.dispatch(`${CHATMESSAGE}/setNetworkDirectMessage`, null);
      activePanel.value = RoomPanel.WORKSTATION_CHAT;
    }
  },
  { immediate: true, deep: true }
);
const pusher = inject("pusher") as any;
const subscribeChannelList = ref([]) as any;
const subscribeDisputeProjectChannelList = ref([]) as any;
const getRoomImageSrc = (room: any) => {
  if (room.isUserChat && !room.isGroup) {
    return getWorkStationImagePublicUrl(room?.toUser?.profileImage);
  } else if (room.isGroup) {
    if (room.project) {
      return getWorkStationImagePublicUrl(room?.groupAvatar);
    } else {
      return getWorkStationImagePublicUrl(room?.groupAvatar);
    }
  } else if (!room.isUserChat && !room.isGroup) {
    return getWorkStationImagePublicUrl(room?.toWorkstationId?.profileImage);
  }
  return "";
};
const getRoomName = (room: any) => {
  if (isMemberRoom(room)) {
    return `${room?.toUser?.firstName} ${room?.toUser?.lastName}`;
  }
  if (isProjectRoom(room)) {
    if (room.chatType === ChatTypeEnum.DISPUTE_PROJECT) {
      return "Dispute - " + room?.groupName;
    }
    return room?.groupName;
  }
  if (isGroupRoom(room)) {
    return room?.groupName;
  }
  if (isWorkStationRoom(room)) {
    return room?.toWorkstationId?.name;
  }
  return "";
};

const shouldShowDeleteButton = (room: any) => {
  if (isGroupRoom(room)) {
    return (
      room?.fromWorkstationId?.id === activeUserWorkstation.value?.id &&
      room?.fromUser?.id === user.value?.id
    );
  }

  return true;
};

const isMemberRoom = (room: any): boolean => {
  return room.isUserChat && !room.isGroup;
};

const isGroupRoom = (room: {
  isGroup: boolean;
  project?: boolean;
}): boolean => {
  return room.isGroup && !room.project;
};

const isProjectRoom = (room: any): boolean => {
  if (room.project?.id && room.isGroup) {
    return isProjectOwner.value
      ? room.status !== UserMessagesRoomStatusEnum.PENDING
      : true;
  }
  return false;
};

const isWorkStationRoom = (room: any): boolean => {
  return !room.isUserChat && !room.isGroup;
};

const addNewUserMessagesToRoom = (
  userMessageRoomId: any,
  userNewMessage: any
) => {
  const findUserMessages = chatRooms.value.find((data: any) => {
    return (
      data.userMessageRoomDetails.id === userMessageRoomId ||
      data.userMessageRoomDetails.parentId === userMessageRoomId
    );
  });

  if (findUserMessages) {
    findUserMessages?.userMessages.unshift(userNewMessage);
  }
};
const appendLatestMessages = (
  userMessageRoomId: number,
  userNewMessage: any
) => {
  const findUserMessageRoom = getChatMessagesRooms.value.find(
    (data: any) => data.id === userMessageRoomId
  );
  if (findUserMessageRoom) {
    const isOpenChats = chatRooms.value.find(
      (room: any) => room?.userMessageRoomDetails?.id === userMessageRoomId
    );
    if (!isOpenChats && userNewMessage.toUser?.id === user.value.id) {
      findUserMessageRoom.unreadMessagesCount++;
    }

    //dispute project disputeOffer
    if (
      findUserMessageRoom.chatType === ChatTypeEnum.DISPUTE_PROJECT &&
      userNewMessage?.disputeOffer &&
      userNewMessage?.disputeOffer?.status === "pending"
    ) {
      findUserMessageRoom.dispute = {
        ...findUserMessageRoom.dispute,
        dispute_offers: userNewMessage?.disputeOffer
          ? [userNewMessage?.disputeOffer]
          : [],
      };
    }

    findUserMessageRoom.userMessages = userNewMessage;
    const obj = {
      id: userNewMessage.id,
      statuses: [...userNewMessage?.statuses],
    };

    if (!Array.isArray(findUserMessageRoom?.userMessageStatus)) {
      findUserMessageRoom.userMessageStatus = [];
    }
    findUserMessageRoom?.userMessageStatus?.unshift(obj);

    if (isOpenChats) {
      const messageRoom = filterChatMessageRoom.value?.find((room: any) => {
        return room.id == userNewMessage.userMessageRoom.id;
      });
      messageRoom?.userMessageStatus?.forEach((msgstatus: any) => {
        if (msgstatus.id == userNewMessage.id) {
          msgstatus?.statuses.forEach((status: any) => {
            if (
              status.user.id === user.value.id &&
              status.userWorkstation.id === activeUserWorkstation.value.id
            ) {
              status.state = "read";
            }
          });
        }
      });

      store.dispatch(
        `${CHATMESSAGE}/modifyChatMessageRoomAfterNewMesage`,
        messageRoom
      );
    }
  }
};

const subscribeUserMessageRoom = (roomId: { roomId: number }) => {
  const roomChannel = pusher?.subscribe(`new-messages-${roomId}`);
  roomChannel
    ?.unbind("new.message")
    ?.bind("new.message", (userNewMessage: any) => {
      let userMessageRoomId = userNewMessage?.userMessageRoom?.id;
      appendLatestMessages(userMessageRoomId, userNewMessage);

      if (userNewMessage?.userMessageRoom?.isUserChat && userNewMessage) {
        if (user.value.id !== userNewMessage.fromUser.id)
          addNewUserMessagesToRoom(userMessageRoomId, userNewMessage);
      } else {
        if (
          activeUserWorkstation.value.id !==
            userNewMessage.fromWorkstationId.id ||
          // activeUserWorkstation.value.user.id !== user.value.id
          user.value.id !== userNewMessage.fromUser.id
        )
          addNewUserMessagesToRoom(userMessageRoomId, userNewMessage);
      }
      return;
    });

  roomChannel
    ?.unbind("delete.message.room")
    ?.bind("delete.message.room", (userRoom: any) => {
      if (
        userRoom.isGroup &&
        userRoom.fromWorkstationId?.id === activeUserWorkstation.value.id &&
        userRoom.fromUser?.id === user.value.id
      )
        return;

      const filterUserMessage = getChatMessagesRooms.value.filter(
        (room: any) => room.id !== userRoom.id
      );
      const filterChatRooms = chatRooms.value.filter(
        (msgRoom: any) => msgRoom?.userMessageRoomDetails?.id !== userRoom.id
      );

      store.commit(`${CHATMESSAGE}/setChatBoxRooms`, filterChatRooms);
      store.commit(`${CHATMESSAGE}/setFilterMessageRooms`, filterUserMessage);
      store.commit(`${CHATMESSAGE}/setUserRoomMessages`, filterUserMessage);
      return;
    });

  roomChannel
    ?.unbind("project.chat.status")
    ?.bind("project.chat.status", async (roomData: any) => {
      if (roomData) {
        if (roomData.isRemove) {
          const filterUserMessage = getChatMessagesRooms.value.filter(
            (msgRoom: any) => msgRoom?.id !== roomData.roomId
          );
          store.commit(
            `${CHATMESSAGE}/setFilterMessageRooms`,
            filterUserMessage
          );
          store.commit(`${CHATMESSAGE}/setUserRoomMessages`, filterUserMessage);
        }
        await init();
        return;
      }
    });
  const attachmentChannel = pusher?.subscribe(
    `new-messages-attachment-${roomId}`
  );
  attachmentChannel
    ?.unbind("new.message-attachment")
    ?.bind("new.message-attachment", (msgAttachments: any) => {
      const userNewAttachmentMessage = {
        id: msgAttachments?.id,
        content: msgAttachments?.originalName,
        dateCreated: msgAttachments?.dateCreated,
      };
      appendLatestMessages(
        msgAttachments?.userMessageRoom?.id,
        userNewAttachmentMessage
      );
      if (
        msgAttachments &&
        activeUserWorkstation.value.id !==
          msgAttachments.createdByUserWorkStation
      )
        appendNewAttachmentToRoom(msgAttachments);
    });
  subscribeChannelList.value.push(roomChannel);
  subscribeChannelList.value.push(attachmentChannel);
};

const unbindSubscribedMessagesChannels = () => {
  if (subscribeChannelList.value.length) {
    subscribeChannelList.value.forEach((channel: any) => {
      // Unbind all events from channel
      channel.unbind();
      pusher?.unsubscribe(channel.name);
    });
    subscribeChannelList.value.length = [];
  }
};
const unbindSubscribeDisputeProject = () => {
  if (subscribeDisputeProjectChannelList.value.length) {
    subscribeDisputeProjectChannelList.value.forEach((channel: any) => {
      channel?.unbind();
      pusher?.unsubscribe(channel.name);
    });
    subscribeDisputeProjectChannelList.value.length = [];
  }
};

const appendNewAttachmentToRoom = (attachmentsMessage: any) => {
  const findUserMessageRoom = chatRooms.value.find(
    (room: any) =>
      room.userMessageRoomDetails.id === attachmentsMessage?.userMessageRoom.id
  );

  if (findUserMessageRoom) {
    const findMessage = findUserMessageRoom.userMessages.find(
      (msg: any) => msg.id === attachmentsMessage?.userMessageId?.id
    );
    if (findMessage) {
      findMessage.userMessageRoom.userMessageAttachments = [];
      findMessage.userMessageRoom.userMessageAttachments.push(
        attachmentsMessage
      );
    }
  }
};

const deleteChat = async (message: any) => {
  const id = message?.id;
  try {
    const filterUserMessage = getChatMessagesRooms.value.filter(
      (el: any) => el.id !== id
    );
    store.commit(`${CHATMESSAGE}/setFilterMessageRooms`, filterUserMessage);
    store.commit(`${CHATMESSAGE}/setUserRoomMessages`, filterUserMessage);

    const filterChatRooms = [...chatRooms.value].filter(
      (el: any) => el.userMessageRoomDetails.id !== id
    );
    store.commit(`${CHATMESSAGE}/setChatBoxRooms`, filterChatRooms);
    await chatService.deleteUserMessages(id);
  } catch (error) {
    console.log(error);
  }
};

const showDeleteDropdown = ref(
  Array(filterChatMessageRoom.value.length).fill(false)
);

//To show delet dropdown as per ID
const dropdownAction = (idx: any) => {
  showDeleteDropdown.value.forEach((value, index) => {
    if (index !== idx) {
      showDeleteDropdown.value[index] = false;
    }
  });

  // Toggle the dropdown at idx
  showDeleteDropdown.value[idx] = !showDeleteDropdown.value[idx];
};

//To handle the back button on group chat layers
const handleBackButton = () => {
  if (!isCreateNewGroupChat.value) {
    isCreateChat.value = !isCreateChat.value;
  }

  if (isCreateNewGroupChat.value) {
    isCreateNewGroupChat.value = !isCreateNewGroupChat.value;
  }
};

const handleMouseLeave = (idx: any) => {
  showDeleteDropdown.value[idx] = false;
};
const subscribeDisputeProjectRequest = (room: any) => {
  const roomChannel = pusher?.subscribe(
    `dispute-project-${room?.id}-${room.project?.id}`
  );
  roomChannel
    ?.unbind("dispute.project.room")
    ?.bind("dispute.project.room", (disputeData: any) => {
      const selectedRoom = chatRooms.value.find(
        (room: any) =>
          room.userMessageRoomDetails.id === disputeData.userMessageRoom?.id
      );

      if (!selectedRoom) {
        return;
      }
      if (disputeData && disputeData.type === "close-dispute-project") {
        const closeProposal = disputeData?.dispute?.close_proposal;
        const disputePayload = {
          id: selectedRoom?.userMessageRoomDetails.id,
          dispute: {
            ...selectedRoom?.userMessageRoomDetails.dispute,
            close_proposal: closeProposal ? [closeProposal] : [],
          },
        };

        store.commit(
          `${CHATMESSAGE}/updateDisputeChatMessageRoom`,
          disputePayload
        );
      } else if (disputeData && disputeData.type === "accept-dispute-project") {
        const disputePayload = {
          id: selectedRoom?.userMessageRoomDetails.id,
          dispute: {
            ...selectedRoom?.userMessageRoomDetails.dispute,
            disputeType: disputeData?.dispute?.disputeType,
          },
        };
        store.commit(
          `${CHATMESSAGE}/updateDisputeChatMessageRoom`,
          disputePayload
        );
      } else if (disputeData && disputeData.type === "reject-dispute-project") {
        const disputePayload = {
          id: selectedRoom?.userMessageRoomDetails.id,
          dispute: {
            ...selectedRoom?.userMessageRoomDetails.dispute,
            disputeType: disputeData?.dispute?.disputeType,
          },
        };
        store.commit(
          `${CHATMESSAGE}/updateDisputeChatMessageRoom`,
          disputePayload
        );
      }
    });

  subscribeDisputeProjectChannelList.value.push(roomChannel);
};

onBeforeUnmount(() => {
  unbindSubscribedMessagesChannels();
  unbindSubscribeDisputeProject();
  store.dispatch(`${CHATMESSAGE}/setNetworkDirectMessage`, null);
});

const getUserWorkStationProfileImage = async (profileImage: any) => {
  if (!profileImage) return null;
  //check first in common map img exits to directly store to chat map
  if (profileImage in profileImagesData) {
    const imgUrl = profileImagesData[profileImage];
    addUserImage(profileImage, imgUrl);
    return;
  }

  //check profileImage in chat map
  if (!keyExists(profileImage)) {
    const imageUrl = setDirectStoragePathToImage(profileImage, true);
    try {
      addUserImage(profileImage, imageUrl);
      return imageUrl;
    } catch (error) {
      return null;
    }
  }
};
const getWorkStationImagePublicUrl = (profileImage: string | null) => {
  if (!profileImage) return require("@/assets/images/user-placeholder.png");

  const imgUrl = userImagesMap.value[profileImage];
  if (!imgUrl) return require("@/assets/images/user-placeholder.png");

  return imgUrl;
};

const filteredUsersNetworkList = computed(() => {
  const searchTerm = searchNetworkUsers?.value?.trim()?.toLowerCase();
  if (searchTerm && searchTerm !== "") {
    //search both with userWorkstation and user
    return usersNetworkList.value.filter(
      (user: any) =>
        user?.receiverWorkstation?.name?.toLowerCase().includes(searchTerm) ||
        user?.receiverWorkstation?.user?.firstName
          .toLowerCase()
          .includes(searchTerm) ||
        user?.receiverWorkstation?.user?.lastName
          .toLowerCase()
          .includes(searchTerm)
    );
  }
  return usersNetworkList.value;
});

const onlineUser = computed(
  () => store.getters[`${WORKSTATION}/getUserOnlineWorkStations`]
);
const isUserWorkStationOnline = (wsId: number) => {
  const isExist = onlineUser.value?.find(
    (data: any) => data?.userWorkstations?.id === wsId
  );
  return isExist ? true : false;
};
const isUserOnline = (userId: number) => {
  return onlineUser.value?.find((user: any) => user.id == userId)
    ? true
    : false;
};

const totalUnreadMessageCount = computed(() => {
  let countMsg = 0;
  filterChatMessageRoom.value.forEach((msg: any) => {
    if (msg?.unreadMessagesCount && !msg?.isGroup) {
      countMsg++;
    }
  });
  return countMsg + (groupsUnreadMsgCount.value > 0 ? 1 : 0);
});
const onClickVideoCallButton = (
  msgId: number,
  senderUserWorkstationId: number,
  receiverUserWorkstationId: number,
  roomId: number
) => {
  closeMessageChatBox(msgId, true);
  if (roomId) {
    roomDetails.value[
      "title"
    ] = `group-call-${senderUserWorkstationId}-${roomId}`;
    roomDetails.value[`type`] = CallTypesEnums.GROUP_CALL;
  } else {
    roomDetails.value[
      "title"
    ] = `video-call-${senderUserWorkstationId}-${receiverUserWorkstationId}`;
    roomDetails.value[`type`] = CallTypesEnums.VIDEO_CALL;
  }
  videoConsultationStatus.value = true;
  videoComponent.value.onClickVideoCallButton();
};
const onClickArchive = () => {
  isShowArchived.value = !isShowArchived.value;

  if (isShowArchived.value) {
    const filterRoom = allMessagesRooms.value.filter(
      (room: any) => room.isArchiveRoom
    );
    store.commit(`${CHATMESSAGE}/setFilterMessageRooms`, filterRoom);
  } else {
    const filterRoom = allMessagesRooms.value.filter(
      (room: any) => !room.isArchiveRoom
    );
    store.commit(`${CHATMESSAGE}/setFilterMessageRooms`, filterRoom);
  }
};

const archiveRoom = async (room: any) => {
  if (isShowArchived.value) {
    await store.dispatch(`${CHATMESSAGE}/unArchiveMessageRoom`, {
      ...room,
      isArchiveRoom: false,
    });
  } else
    await store.dispatch(`${CHATMESSAGE}/archiveMessageRoom`, {
      ...room,
      isArchiveRoom: true,
    });
};

const leaveCall = () => {
  videoConsultationStatus.value = false;
};

const isKrystalChatActive = ref(false);
const openKrystalChat = () => {
  isKrystalChatActive.value = true;
};
const closeKrystalChat = () => {
  isKrystalChatActive.value = false;
};

const getKrystalConversationLastAnswer: any = computed(
  () => store.getters[`${CHATMESSAGE}/getKrystalConversationLastAnswer`]
);
const usersList = computed(() => {
  return filteredUsersNetworkList.value.filter(
    (member: any) => member.isUserChat
  );
});
const workStationList = computed(() => {
  return filteredUsersNetworkList.value.filter(
    (member: any) => !member.isUserChat
  );
});

const handleSort = (sortingOrder: any) => {
  if (sortingOrder) {
    isSort.value = true;
  } else {
    isSort.value = false;
  }

  filterChatMessageRoom.value.sort(
    (a: { dateCreated: string | Date }, b: { dateCreated: string | Date }) => {
      const dateA = new Date(a.dateCreated).getTime();
      const dateB = new Date(b.dateCreated).getTime();
      if (!isSort.value) {
        return dateA - dateB;
      } else {
        return dateB - dateA;
      }
    }
  );
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_KrystalChatComponent = _resolveComponent("KrystalChatComponent")!

  return (getCurrentMessageType.value === 'chat')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["chatbox__wrapper", { chatbox_active: isOpenMessageChatBox.value }])
        }, [
          _createVNode(_component_v_card, {
            class: "chatbox__inner",
            variant: "flat"
          }, {
            text: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["chatbox__top", isCreateChat.value ? 'back__section' : '']),
                onClick: toggleChatBox
              }, [
                _createElementVNode("div", _hoisted_2, [
                  (isCreateChat.value)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        icon: "mdi-chevron-left",
                        onClick: _withModifiers(handleBackButton, ["stop"])
                      }))
                    : _createCommentVNode("", true),
                  _hoisted_3
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_v_icon, {
                    onClick: closeChatBox,
                    class: "close_icon md:!tw-invisible"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: require('@/assets/icons/cancel.svg'),
                        alt: "",
                        onClick: closeChatBox
                      }, null, 8, _hoisted_5)
                    ]),
                    _: 1
                  })
                ])
              ], 2),
              _createElementVNode("div", _hoisted_6, [
                (!isLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (isCreateChat.value && !isCreateNewGroupChat.value)
                        ? (_openBlock(), _createBlock(_component_v_text_field, {
                            key: 0,
                            class: "chatbox__search create_group__search",
                            modelValue: searchNetworkUsers.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchNetworkUsers).value = $event)),
                            label: "Search",
                            "prepend-inner-icon": "mdi-magnify",
                            variant: "solo-filled",
                            "hide-details": "",
                            "single-line": "",
                            flat: "",
                            placeholder: "Search"
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      (!isCreateNewGroupChat.value && !isCreateChat.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_v_text_field, {
                                class: "chatbox__search",
                                modelValue: searchChats.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchChats).value = $event)),
                                label: "Search",
                                "prepend-inner-icon": "mdi-magnify",
                                variant: "solo-filled",
                                "hide-details": "",
                                "single-line": "",
                                flat: "",
                                placeholder: "Search"
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", {
                                class: "chatbox__edit",
                                onClick: onCreateNewChat
                              }, [
                                _createElementVNode("img", {
                                  src: require('@/assets/icons/' + 'edit-chat.svg'),
                                  alt: ""
                                }, null, 8, _hoisted_10)
                              ]),
                              _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_v_menu, {
                                  class: "chat-panel__filter__wrapper",
                                  persistent: false,
                                  "close-on-content-click": false,
                                  "scroll-strategy": "close"
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_btn, _mergeProps({
                                      density: "compact",
                                      flat: "",
                                      ripple: false
                                    }, props, { class: "button button-purple chat-panel__filter-button" }), {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                          default: _withCtx(() => [
                                            _hoisted_12
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1040)
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_13, [
                                      _createVNode(_component_v_expansion_panels, { multiple: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_expansion_panel, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_expansion_panel_title, {
                                                "collapse-icon": "mdi-chevron-down",
                                                "expand-icon": "mdi-chevron-right"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Sort by")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_expansion_panel_text, null, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_14, [
                                                    _createVNode(_component_v_btn, {
                                                      density: "text",
                                                      flat: "",
                                                      ripple: false,
                                                      class: "chat-panel__filter-item"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" Selection "),
                                                        _createVNode(_component_v_icon, {
                                                          color: "#FFA500",
                                                          icon: "mdi-checkbox-marked-circle"
                                                        })
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_btn, {
                                                      density: "text",
                                                      flat: "",
                                                      ripple: false,
                                                      class: _normalizeClass(["chat-panel__filter-item", {
                                    'is-active': isSort.value === true,
                                  }]),
                                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (handleSort(true)))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" Newest to Old "),
                                                        _createVNode(_component_v_icon, {
                                                          color: "#FFA500",
                                                          icon: "mdi-checkbox-marked-circle"
                                                        })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["class"]),
                                                    _createVNode(_component_v_btn, {
                                                      density: "text",
                                                      flat: "",
                                                      ripple: false,
                                                      class: _normalizeClass(["chat-panel__filter-item", {
                                    'is-active': isSort.value === false,
                                  }]),
                                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (handleSort(false)))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" Oldest to New "),
                                                        _createVNode(_component_v_icon, {
                                                          color: "#FFA500",
                                                          icon: "mdi-checkbox-marked-circle"
                                                        })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["class"])
                                                  ])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_expansion_panel, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_expansion_panel_title, {
                                                "collapse-icon": "mdi-chevron-down",
                                                "expand-icon": "mdi-chevron-right"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Filter")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_expansion_panel_text, null, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_15, [
                                                    _createVNode(_component_v_btn, {
                                                      density: "text",
                                                      flat: "",
                                                      ripple: false,
                                                      class: _normalizeClass(["chat-panel__filter-item", {
                                    'is-active': selectedFilter.value === 'all',
                                  }]),
                                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (filterRooms('all')))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" All "),
                                                        _createVNode(_component_v_icon, {
                                                          color: "#FFA500",
                                                          icon: "mdi-checkbox-marked-circle"
                                                        })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["class"]),
                                                    _createVNode(_component_v_btn, {
                                                      density: "text",
                                                      flat: "",
                                                      ripple: false,
                                                      class: _normalizeClass(["chat-panel__filter-item", {
                                    'is-active':
                                      selectedFilter.value === 'group_chats',
                                  }]),
                                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (filterRooms('group_chats')))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" Groups Chat "),
                                                        _createVNode(_component_v_icon, {
                                                          color: "#FFA500",
                                                          icon: "mdi-checkbox-marked-circle"
                                                        })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["class"]),
                                                    _createVNode(_component_v_btn, {
                                                      density: "text",
                                                      flat: "",
                                                      ripple: false,
                                                      class: _normalizeClass(["chat-panel__filter-item", {
                                    'is-active':
                                      selectedFilter.value === 'project_chats',
                                  }]),
                                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (filterRooms('project_chats')))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" Project Chat "),
                                                        _createVNode(_component_v_icon, {
                                                          color: "#FFA500",
                                                          icon: "mdi-checkbox-marked-circle"
                                                        })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["class"]),
                                                    _createVNode(_component_v_btn, {
                                                      density: "text",
                                                      flat: "",
                                                      ripple: false,
                                                      class: _normalizeClass(["chat-panel__filter-item", {
                                    'is-active':
                                      selectedFilter.value === 'workstation_members',
                                  }]),
                                                      onClick: _cache[7] || (_cache[7] = ($event: any) => (filterRooms('workstation_members')))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" Workstation Members "),
                                                        _createVNode(_component_v_icon, {
                                                          color: "#FFA500",
                                                          icon: "mdi-checkbox-marked-circle"
                                                        })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["class"]),
                                                    _createVNode(_component_v_btn, {
                                                      density: "text",
                                                      flat: "",
                                                      ripple: false,
                                                      class: _normalizeClass(["chat-panel__filter-item", {
                                    'is-active':
                                      selectedFilter.value === 'workstation_chats',
                                  }]),
                                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (filterRooms('workstation_chats')))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(isProjectOwner.value
                                      ? "Connection Chat"
                                      : "Trade Network Chat") + " ", 1),
                                                        _createVNode(_component_v_icon, {
                                                          color: "#FFA500",
                                                          icon: "mdi-checkbox-marked-circle"
                                                        })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["class"])
                                                  ])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", {
                              class: "archive__chatbox__wrapper",
                              onClick: onClickArchive
                            }, [
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                  (isShowArchived.value)
                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 0,
                                        icon: "mdi-chevron-left"
                                      }))
                                    : (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        src: require('@/assets/icons/archive-icon.svg'),
                                        alt: "archive"
                                      }, null, 8, _hoisted_18))
                                ]),
                                _hoisted_19
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["custom_chip", { 'active-panel-sort': selectedFilter.value === 'all' }]),
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (filterRooms('all')))
                                }, [
                                  _hoisted_22,
                                  (
                          membersUnreadMsgCount.value +
                            groupsUnreadMsgCount.value +
                            projectsUnreadMsgCount.value +
                            workStationUnreadMsgCount.value >
                          0
                        )
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(membersUnreadMsgCount.value +
                          groupsUnreadMsgCount.value +
                          projectsUnreadMsgCount.value +
                          workStationUnreadMsgCount.value), 1))
                                    : _createCommentVNode("", true)
                                ], 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["custom_chip", {
                        'active-panel-sort': selectedFilter.value === 'group_chats',
                      }]),
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (filterRooms('group_chats')))
                                }, [
                                  _hoisted_24,
                                  (groupsUnreadMsgCount.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(groupsUnreadMsgCount.value), 1))
                                    : _createCommentVNode("", true)
                                ], 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["custom_chip", {
                        'active-panel-sort': selectedFilter.value === 'project_chats',
                      }]),
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (filterRooms('project_chats')))
                                }, [
                                  _hoisted_26,
                                  (projectsUnreadMsgCount.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(projectsUnreadMsgCount.value), 1))
                                    : _createCommentVNode("", true)
                                ], 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["custom_chip", {
                        'active-panel-sort':
                          selectedFilter.value === 'workstation_members',
                      }]),
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (filterRooms('workstation_members')))
                                }, [
                                  _hoisted_28,
                                  (membersUnreadMsgCount.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(membersUnreadMsgCount.value), 1))
                                    : _createCommentVNode("", true)
                                ], 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["custom_chip", {
                        'active-panel-sort':
                          selectedFilter.value === 'workstation_chats',
                      }]),
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (filterRooms('workstation_chats')))
                                }, [
                                  _hoisted_30,
                                  (workStationUnreadMsgCount.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(workStationUnreadMsgCount.value), 1))
                                    : _createCommentVNode("", true)
                                ], 2)
                              ]),
                              _createElementVNode("div", {
                                class: _normalizeClass(["chatbox__list no-scrollbar tw-cursor-none", { 'without-krystal': !isKrystalChatActive.value }])
                              }, [
                                (!filteredRooms.value.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                      _createElementVNode("div", _hoisted_33, [
                                        _hoisted_34,
                                        _hoisted_35,
                                        _createElementVNode("p", _hoisted_36, " Get started by messaging " + _toDisplayString(filterNames.value[selectedFilter.value]), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_37, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_38, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredRooms.value, (room, idx) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: _normalizeClass(["chat-member chat-member-team", {
                              '!tw-items-center':
                                isProjectRoom(room) && isProjectChatLock(room),
                            }]),
                                          key: room.id,
                                          onClick: ($event: any) => (openMessageChatBox(room)),
                                          onMouseleave: ($event: any) => (handleMouseLeave(idx))
                                        }, [
                                          _createElementVNode("div", _hoisted_40, [
                                            (
                                  isProjectRoom(room) &&
                                  room?.project &&
                                  room?.project?.id
                                )
                                              ? (_openBlock(), _createBlock(UserProfileLogo, {
                                                  key: 0,
                                                  userName: room?.groupName
                                                }, null, 8, ["userName"]))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("img", {
                                              loading: "lazy",
                                              src: getRoomImageSrc(room),
                                              alt: "group_icon"
                                            }, null, 8, _hoisted_41)
                                          ]),
                                          (isMemberRoom(room))
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: _normalizeClass(["status_wrapper", 
                                isUserOnline(room?.toUser?.id)
                                  ? 'online'
                                  : 'offline'
                              ])
                                              }, null, 2))
                                            : _createCommentVNode("", true),
                                          (
                                isWorkStationRoom(room) &&
                                isUserWorkStationOnline(
                                  room?.toWorkstationId?.id
                                )
                              )
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_42))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_43)),
                                          _createElementVNode("div", _hoisted_44, [
                                            _createElementVNode("div", _hoisted_45, [
                                              _createElementVNode("div", _hoisted_46, [
                                                _createElementVNode("p", _hoisted_47, _toDisplayString(getRoomName(room)), 1)
                                              ]),
                                              (
                                    isProjectRoom(room) &&
                                    isProjectChatLock(room)
                                  )
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                    _createVNode(_component_v_tooltip, {
                                                      "max-width": "242px",
                                                      activator: "parent",
                                                      location: "top",
                                                      class: "estimate_tooltip"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" Project Chat is locked ")
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_icon, {
                                                      icon: "mdi mdi-lock",
                                                      color: "#0C0F4A"
                                                    })
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (!isProjectRoom(room))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                                    _createElementVNode("p", null, _toDisplayString(getTimeElapsedString(
                                        room?.userMessages?.dateCreated
                                      )), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (
                                    isProjectRoom(room) &&
                                    !isProjectChatLock(room)
                                  )
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                                    _createElementVNode("p", null, _toDisplayString(getTimeElapsedString(
                                        room?.userMessages?.dateCreated
                                      )), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["chat-panel__setting-menu", {
                                    'is-active': showDeleteDropdown.value[idx],
                                  }])
                                              }, [
                                                _createElementVNode("div", _hoisted_51, [
                                                  (!isProjectRoom(room))
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: _imports_2,
                                                        alt: "",
                                                        onClick: _withModifiers(($event: any) => (dropdownAction(idx)), ["stop"])
                                                      }, null, 8, _hoisted_52))
                                                    : _createCommentVNode("", true),
                                                  (
                                        isProjectRoom(room) &&
                                        !isProjectChatLock(room)
                                      )
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 1,
                                                        src: _imports_2,
                                                        alt: "",
                                                        onClick: _withModifiers(($event: any) => (dropdownAction(idx)), ["stop"])
                                                      }, null, 8, _hoisted_53))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("div", _hoisted_54, [
                                                  _createElementVNode("div", {
                                                    class: "chat-panel__setting-menu-item",
                                                    onClick: _withModifiers(($event: any) => (archiveRoom(room)), ["stop"])
                                                  }, [
                                                    _createElementVNode("img", {
                                                      src: 
                                          require('@/assets/icons/archive-icon.svg')
                                        ,
                                                      alt: "archive"
                                                    }, null, 8, _hoisted_56),
                                                    _createElementVNode("p", null, _toDisplayString(!isShowArchived.value
                                            ? "Archive"
                                            : "UnArchive"), 1)
                                                  ], 8, _hoisted_55),
                                                  (
                                        shouldShowDeleteButton(room) &&
                                        room.chatType !==
                                          _unref(ChatTypeEnum).DISPUTE_PROJECT
                                      )
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 0,
                                                        class: "chat-panel__setting-menu-item",
                                                        onClick: _withModifiers(($event: any) => (deleteChat(room)), ["stop"])
                                                      }, [
                                                        _createVNode(_component_v_icon, { icon: "mdi-delete" }),
                                                        _hoisted_58
                                                      ], 8, _hoisted_57))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ], 2)
                                            ]),
                                            (!isProjectRoom(room))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                                  _createElementVNode("div", _hoisted_60, [
                                                    _createElementVNode("p", null, _toDisplayString(room?.userMessages?.content
                                        ? room?.userMessages?.content
                                        : room?.userMessages?.content !== ""
                                        ? "Start New Conversion "
                                        : "File "), 1)
                                                  ]),
                                                  (getUnreadCount(room) > 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                                        _createElementVNode("p", null, _toDisplayString(getUnreadCount(room)), 1)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true),
                                            (
                                  isProjectRoom(room) &&
                                  !isProjectChatLock(room)
                                )
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                                  _createElementVNode("div", _hoisted_63, [
                                                    _createElementVNode("p", null, _toDisplayString(room?.userMessages?.content
                                        ? room?.userMessages?.content
                                        : room?.userMessages?.content !== ""
                                        ? "Start New Conversion "
                                        : "File "), 1)
                                                  ]),
                                                  (getUnreadCount(room) > 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                                        _createElementVNode("p", null, _toDisplayString(getUnreadCount(room)), 1)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ], 42, _hoisted_39))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ], 2)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (isCreateChat.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                            (!isCreateNewGroupChat.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                  _createElementVNode("div", {
                                    class: "chatbox__top",
                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (onClickGroupChat()))
                                  }, [
                                    _createElementVNode("div", _hoisted_67, [
                                      _createElementVNode("div", _hoisted_68, [
                                        _createVNode(_component_v_icon, { icon: "mdi-account-group" })
                                      ]),
                                      _hoisted_69
                                    ]),
                                    _createElementVNode("div", _hoisted_70, [
                                      _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (!isCreateNewGroupChat.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                  _createVNode(_component_v_tabs, {
                                    modelValue: tab.value,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((tab).value = $event)),
                                    "align-tabs": "center",
                                    stacked: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_tab, {
                                        value: tabs.value[0],
                                        height: "auto"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, " workstation members " + _toDisplayString(`(${usersList.value.length})`), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["value"]),
                                      _createVNode(_component_v_tab, {
                                        value: tabs.value[1],
                                        height: "auto"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, _toDisplayString(isProjectOwner.value ? "Connection" : "Trade Network Chat") + " " + _toDisplayString(`(${workStationList.value.length}) `), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["value"])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  (tab.value === tabs.value[0])
                                    ? (_openBlock(), _createBlock(_component_v_tabs_window, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_72, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usersList.value, (user) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                class: "chat_groups_list_item",
                                                key: user.id,
                                                onClick: ($event: any) => (createMessageChatBox(user))
                                              }, [
                                                _createElementVNode("div", _hoisted_74, [
                                                  _createElementVNode("div", _hoisted_75, [
                                                    _createElementVNode("img", {
                                                      loading: "lazy",
                                                      src: 
                                getWorkStationImagePublicUrl(
                                  user.receiverWorkstation.user?.profileImage
                                )
                                  ? getWorkStationImagePublicUrl(
                                      user.receiverWorkstation.user
                                        ?.profileImage
                                    )
                                  : require('@/assets/images/user-placeholder.png')
                              ,
                                                      alt: "user_img"
                                                    }, null, 8, _hoisted_76)
                                                  ]),
                                                  (
                              isUserOnline(user.receiverWorkstation?.user?.id)
                            )
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_77))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_78)),
                                                  _createElementVNode("div", _hoisted_79, _toDisplayString(user?.toUser?.firstName +
                              " " +
                              user?.toUser?.lastName), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_80, [
                                                  _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
                                                ])
                                              ], 8, _hoisted_73))
                                            }), 128)),
                                            (usersList.value.length === 0)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_81, " No users found "))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (tab.value === tabs.value[1])
                                    ? (_openBlock(), _createBlock(_component_v_tabs_window, { key: 1 }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_82, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workStationList.value, (user) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                class: "chat_groups_list_item",
                                                key: user.id,
                                                onClick: ($event: any) => (createMessageChatBox(user))
                                              }, [
                                                _createElementVNode("div", _hoisted_84, [
                                                  _createElementVNode("div", _hoisted_85, [
                                                    _createElementVNode("img", {
                                                      loading: "lazy",
                                                      src: 
                                getWorkStationImagePublicUrl(
                                  user.receiverWorkstation?.profileImage
                                )
                                  ? getWorkStationImagePublicUrl(
                                      user.receiverWorkstation?.profileImage
                                    )
                                  : require('@/assets/images/user-placeholder.png')
                              ,
                                                      alt: "workStation_img"
                                                    }, null, 8, _hoisted_86)
                                                  ]),
                                                  (
                              isUserWorkStationOnline(
                                user.receiverWorkstation?.id
                              )
                            )
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_87))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_88)),
                                                  _createElementVNode("div", _hoisted_89, _toDisplayString(user?.receiverWorkstation?.name), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_90, [
                                                  _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
                                                ])
                                              ], 8, _hoisted_83))
                                            }), 128)),
                                            (workStationList.value.length === 0)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_91, " No workstation found "))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (isCreateNewGroupChat.value)
                              ? (_openBlock(), _createBlock(NewGroupChatComponent, {
                                  key: 2,
                                  groupNetWorkContactList: usersNetworkList.value,
                                  projectId: projectId.value,
                                  userImagesMap: userImagesMap.value,
                                  onSaveNewUserGroup: saveNewUserGroup
                                }, null, 8, ["groupNetWorkContactList", "projectId", "userImagesMap"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass([isLoading.value ? 'loader__wrapper' : ''])
              }, [
                (isOpenMessageChatBox.value)
                  ? (_openBlock(), _createBlock(CommonLoader, {
                      key: 0,
                      loading: isLoading.value
                    }, null, 8, ["loading"]))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("div", _hoisted_92, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterChatRoom.value, (data) => {
            return (_openBlock(), _createBlock(MessageChatComponent, {
              key: data.userMessageRoomDetails.id,
              projectId: projectId.value,
              userMessageRoomDetails: data.userMessageRoomDetails,
              userAllMessages: data.userMessages,
              receiverUserWorkstation: data.receiverUserWorkstation,
              senderUserWorkstation: data.senderUserWorkstation,
              userImagesMap: userImagesMap.value,
              groupNetWorkContactList: usersNetworkList.value,
              filterMessagesRooms: getChatMessagesRooms.value,
              onCloseMessageChatBox: closeMessageChatBox,
              onSaveNewGroupMembers: saveNewGroupMembers,
              onOnClickVideoCallButton: onClickVideoCallButton,
              onGetUserWorkStationProfileImage: getUserWorkStationProfileImage
            }, null, 8, ["projectId", "userMessageRoomDetails", "userAllMessages", "receiverUserWorkstation", "senderUserWorkstation", "userImagesMap", "groupNetWorkContactList", "filterMessagesRooms"]))
          }), 128)),
          (isKrystalChatActive.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                _createVNode(_component_KrystalChatComponent, { onCloseMessageChatBox: closeKrystalChat })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["chat__overlay", { overlay: isOpenMessageChatBox.value }])
        }, null, 2),
        _withDirectives(_createVNode(VideoComponent, {
          roomDetails: roomDetails.value,
          isDirectJoinVideoCall: false,
          ref_key: "videoComponent",
          ref: videoComponent,
          onLeaveCall: leaveCall
        }, null, 8, ["roomDetails"]), [
          [_vShow, videoConsultationStatus.value]
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})